import * as React from "react";
const SvgFiRrWaveSine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wave-sine_svg__a)">
      <path
        fill="#062147"
        d="M17.5 21c-4.085 0-5.633-5.684-6.465-8.737C10.008 8.491 8.747 5 6.5 5c-1.736 0-4.03 3.888-4.504 9.09a1 1 0 1 1-1.992-.18C.491 8.547 3.055 3 6.5 3c4.085 0 5.633 5.684 6.465 8.737C13.992 15.509 15.253 19 17.5 19c1.736 0 4.031-3.888 4.504-9.09a1 1 0 1 1 1.992.18C23.51 15.453 20.946 21 17.5 21"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wave-sine_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWaveSine;
